export const HEPTAGON_POINTS = "50,4 85.96,21.32 94.85,60.24 69.96,91.45 30.04,91.45 5.15,60.24 14.04,21.32";

export const Heptagon = ({ size = 40, className = "", strokeWidth = 3, animate = false }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden="true">
    <defs>
      <linearGradient id="hepta-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0FB5A3" />
        <stop offset="100%" stopColor="#6D28D9" />
      </linearGradient>
    </defs>
    <polygon
      points={HEPTAGON_POINTS}
      fill="none"
      stroke="url(#hepta-grad)"
      strokeWidth={strokeWidth}
      style={
        animate
          ? { strokeDasharray: 320, strokeDashoffset: 320, animation: "heptaDraw 2s ease forwards" }
          : undefined
      }
    />
    <text
      x="50"
      y="64"
      fontFamily="Clash Display, Georgia, serif"
      fontSize="40"
      fontWeight="600"
      fill="url(#hepta-grad)"
      textAnchor="middle"
    >
      7
    </text>
    {animate && <style>{`@keyframes heptaDraw { to { stroke-dashoffset: 0; } }`}</style>}
  </svg>
);

export const BrandLogo = ({ className = "", eager = false }) => (
  <img
    src="/brand-logo-320.webp"
    srcSet="/brand-logo-160.webp 160w, /brand-logo-320.webp 320w, /brand-logo-640.webp 640w"
    sizes="(max-width: 640px) 160px, 320px"
    alt="7FIFTY7 official logo"
    width="320"
    height="182"
    loading={eager ? "eager" : "lazy"}
    decoding="async"
    fetchPriority={eager ? "high" : "auto"}
    className={className}
  />
);

export const Logo = ({ size = "md", glow = true }) => {
  const sizes = {
    sm: { img: "h-8", text: "text-sm" },
    md: { img: "h-10", text: "text-lg" },
    lg: { img: "h-14", text: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <span className="inline-flex items-center gap-3 select-none" data-testid="brand-logo">
      <img
        src="/brand-logo-160.webp"
        srcSet="/brand-logo-160.webp 160w, /brand-logo-320.webp 320w"
        sizes="160px"
        alt="7FIFTY7 logo"
        width="160"
        height="91"
        loading="eager"
        fetchPriority="high"
        decoding="async"
        className={`${s.img} w-auto ${glow ? "glow-turquoise" : ""}`}
        style={{ borderRadius: "2px" }}
      />
      <span className={`font-display font-semibold tracking-[0.18em] ${s.text} text-white hidden sm:inline`}>
        7FIFTY7<sup className="text-[0.5em] text-[#C9A24B] ml-0.5">™</sup>
      </span>
    </span>
  );
};

export const HeptagonPattern = ({ className = "", opacity = 0.05 }) => (
  <svg
    className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
    aria-hidden="true"
    style={{ contentVisibility: "auto", containIntrinsicSize: "800px 800px" }}
  >
    <defs>
      <pattern id="hepta-pattern" width="140" height="140" patternUnits="userSpaceOnUse">
        <polygon
          points="70,28 91.6,38.4 96.9,61.7 82,80.5 58,80.5 43.1,61.7 48.4,38.4"
          fill="none"
          stroke="#0FB5A3"
          strokeOpacity={opacity}
          strokeWidth="1"
        />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#hepta-pattern)" />
  </svg>
);
